//#region Util Imports

import * as moment from 'moment'
import { formatNumber as globalizeFormatNumber } from 'globalize'

//#endregion

import { Enums } from '../common/enums'
import { OpDataType } from '../core/op-data-type'

import { IReferenceType, IOpObject } from './interfaces'

import { DataProvider } from '../../helpers/data-provider'
import { Dictionary } from '../../helpers/dictionary'
import { TypeHelper } from '../../helpers/type-helper'

import { Utils } from './utils'

export class ObjectCustomString {
    private static mainRegex = /{([0-9]+)\:((PFX_S)([a-zA-Z0-9\s<>\/\\\[\]%:\\']+)(PFX_E)\:)?(DV|DT|CURR_DATE)\.([a-zA-Z0-9_]+)((\:SFX_S)([a-zA-Z0-9\s<>\/\\\[\]%:\\']+)(SFX_E))?}/g
    private static greaterCondition = "GREATER"
    private static lessCondition = "LESS"

    // Mapping from DataType to ReferenceType
    public static customStringsMap: Dictionary<Enums.DataType> = new Dictionary<Enums.DataType>(null)
    public static customMarkerStringsMap: Dictionary<Enums.DataType> = new Dictionary<Enums.DataType>(null)

    public static dataProvider: DataProvider

    public static businessObjectCustomFormatStringDict: Dictionary<string> = new Dictionary<string>(null)

    public static getCustomStringFormat(objectToString: IReferenceType): string {
        if (ObjectCustomString.businessObjectCustomFormatStringDict) {
            var referenceType: Enums.ReferenceType = objectToString.getReferenceType()
            var dateType = ObjectCustomString.customStringsMap.tryGetValue(referenceType)
            var customString = ObjectCustomString.businessObjectCustomFormatStringDict.tryGetValue(dateType)
            if (!Utils.isNullOrEmpty(customString))
                return customString
        }
        return null
    }

    public static getCutomMarkerStringFormat(objectToString: IReferenceType = null, objectReferenceType: Enums.ReferenceType = null): string {
        if (ObjectCustomString.businessObjectCustomFormatStringDict != null) {
            let referenceType: Enums.ReferenceType = null

            if (objectToString != null) {
                referenceType = objectToString.getReferenceType()
            } else if (objectReferenceType != null) {
                referenceType = objectReferenceType
            }

            if (referenceType != null) {
                const dateType: Enums.DataType = ObjectCustomString.customMarkerStringsMap.tryGetValue(referenceType)
                const customString: string = ObjectCustomString.businessObjectCustomFormatStringDict.tryGetValue(dateType)

                if (!TypeHelper.isNullOrEmpty(customString)) {
                    return customString
                }
            }
        }

        return null
    }

    public static getObjectCustomString(format: string, obj: IOpObject): string {
        var mItem: RegExpExecArray, regex = ObjectCustomString.mainRegex
        var result = format
        while (mItem = regex.exec(format)) {
            var type = mItem[6]
            var key = mItem[7]
            var prefix = mItem[4]
            var suffix = mItem[10]

            if (!Utils.isNullOrEmpty(key)) {
                var value = null, dataType: OpDataType = null

                switch (type) {
                    case "DV": {
                        if (obj.dynamicValues) {
                            var values = obj.dynamicValues.filter(dv => dv.Key == key)
                            if (values.length > 0) {
                                value = values[0].Value
                                var split = key.split('_')
                                if (split.length == 3) {
                                    var idDataType = +split[1]
                                    if (!isNaN(idDataType)) {
                                        dataType = ObjectCustomString.dataProvider.DataType.getDataTypeLocal(idDataType)
                                    }
                                } else if (split.length == 1) {
                                    var idDataType = +split[0]
                                    if (!isNaN(idDataType)) {
                                        dataType = ObjectCustomString.dataProvider.DataType.getDataTypeLocal(idDataType)
                                    }
                                }
                            }
                        }
                        break;
                    }
                    case "DT": {
                        var idDataType = +key
                        if (idDataType > 0 && !isNaN(idDataType)) {
                            value = obj.dataList.getValue(idDataType)
                            dataType = ObjectCustomString.dataProvider.DataType.getDataTypeLocal(idDataType)
                        }

                        break;
                    }
                    case "CURR_DATE": {
                        var split = key.split('_').filter(v => !Utils.isNullOrEmpty(v))
                        if (split.length == 3) {
                            var interval = split[0]
                            var condition = split[1]
                            var amount = +split[2]
                            if (!isNaN(amount)) {
                                var date = new Date()
                                if (condition == ObjectCustomString.lessCondition)
                                    amount = -amount
                                value = Utils.dateAdd(date, interval, amount)
                            }
                        }
                        break;
                    }
                }

                if (value) {
                    if (dataType) {
                        switch (dataType.idDataTypeClass) {
                            case Enums.DataTypeClass.Real:
                            case Enums.DataTypeClass.Decimal:
                                value = value != null ? globalizeFormatNumber(+value) : ''

                                break
                            case Enums.DataTypeClass.Date:
                                var dateFormat = window['simax'].getDateTimeFormat('DATE_FORMAT_MOMENTJS', dataType.idDataType)
                                value = moment(value).format(dateFormat)
                                break
                            case Enums.DataTypeClass.Datetime:
                                var dateFormat = window['simax'].getDateTimeFormat('DATE_TIME_FORMAT_MOMENTJS', dataType.idDataType)
                                value = moment(value).format(dateFormat)
                                break
                        }
                    }

                    if (value instanceof Date) {
                        var dateFormat = window['simax'].getDateTimeFormat('DATE_TIME_FORMAT_MOMENTJS')
                        value = moment(value).format(dateFormat)
                    }

                    if (!Utils.isNullOrEmpty(prefix))
                        value = prefix + value;
                    if (!Utils.isNullOrEmpty(suffix))
                        value = value + suffix;
                }

                result = result.replace(mItem[0], !value ? '' : value)
            }
        }

        return result
    }
}

ObjectCustomString.customStringsMap.addOrUpdate(Enums.ReferenceType.IdLocation, Enums.DataType.PROFILE_LOCATION_CUSTOM_FORMAT_STRING)
ObjectCustomString.customStringsMap.addOrUpdate(Enums.ReferenceType.SerialNbr, Enums.DataType.PROFILE_DEVICE_CUSTOM_FORMAT_STRING)
ObjectCustomString.customStringsMap.addOrUpdate(Enums.ReferenceType.IdMeter, Enums.DataType.PROFILE_METER_CUSTOM_FORMAT_STRING)
ObjectCustomString.customStringsMap.addOrUpdate(Enums.ReferenceType.IdTask, Enums.DataType.PROFILE_TASK_CUSTOM_FORMAT_STRING)
ObjectCustomString.customStringsMap.addOrUpdate(Enums.ReferenceType.IdIssue, Enums.DataType.PROFILE_ISSUE_CUSTOM_FORMAT_STRING)
ObjectCustomString.customStringsMap.addOrUpdate(Enums.ReferenceType.IdRoute, Enums.DataType.PROFILE_ROUTE_CUSTOM_FORMAT_STRING)
ObjectCustomString.customStringsMap.addOrUpdate(Enums.ReferenceType.IdReport, Enums.DataType.PROFILE_REPORT_CUSTOM_FORMAT_STRING)
ObjectCustomString.customStringsMap.addOrUpdate(Enums.ReferenceType.IdSimCard, Enums.DataType.PROFILE_SIM_CARD_CUSTOM_FORMAT_STRING)
ObjectCustomString.customStringsMap.addOrUpdate(Enums.ReferenceType.IdOperator, Enums.DataType.PROFILE_OPERATOR_CUSTOM_FORMAT_STRING)
ObjectCustomString.customStringsMap.addOrUpdate(Enums.ReferenceType.IdDistributor, Enums.DataType.PROFILE_DISTRIBUTOR_CUSTOM_FORMAT_STRING)

ObjectCustomString.customMarkerStringsMap.addOrUpdate(Enums.ReferenceType.IdLocation, Enums.DataType.PROFILE_LOCATION_MARKER_CUSTOM_FORMAT_STRING)
ObjectCustomString.customMarkerStringsMap.addOrUpdate(Enums.ReferenceType.IdMeter, Enums.DataType.PROFILE_METER_MARKER_CUSTOM_FORMAT_STRING)
ObjectCustomString.customMarkerStringsMap.addOrUpdate(Enums.ReferenceType.SerialNbr, Enums.DataType.PROFILE_DEVICE_MARKER_CUSTOM_FORMAT_STRING)
ObjectCustomString.customMarkerStringsMap.addOrUpdate(Enums.ReferenceType.IdTask, Enums.DataType.PROFILE_TASK_MARKER_CUSTOM_FORMAT_STRING)
